var defaults = {
  stiffness: 100.0,
  damping: 10.0,
  mass: 1.0
};
export { defaults };